var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filled / Building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_COLOR",
    d: "M14.1667 3.33332V1.66666H5.83337V3.33332H3.33337V18.3333H8.33337V16.6667H11.6667V18.3333H16.6667V3.33332H14.1667ZM9.16671 14.1667H7.50004V12.5H9.16671V14.1667ZM9.16671 10.8333H7.50004V9.16666H9.16671V10.8333ZM9.16671 7.49999H7.50004V5.83332H9.16671V7.49999ZM12.5 14.1667H10.8334V12.5H12.5V14.1667ZM12.5 10.8333H10.8334V9.16666H12.5V10.8333ZM12.5 7.49999H10.8334V5.83332H12.5V7.49999Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.202d1f75261002940a2631632a44dc84.svg";
export { ForwardRef as ReactComponent };